import { useModal } from '@flecto/ui'

import {
  ModalBookingActionCreateContract,
  type ModalBookingActionCreateContractProps,
} from '../components/ModalBookingActionCreateContract/ModalBookingActionCreateContract'

export function useModalBookingActionCreateContract(
  props: ModalBookingActionCreateContractProps
) {
  return useModal(<ModalBookingActionCreateContract {...props} />, {
    closeOnBackdropClick: false,
    closeOnEscKey: false,
  })
}
